import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import { formatApiErrorDetail } from "../lib/api";
import { LOGO_URL } from "../lib/i18n";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-12">
          <img src={LOGO_URL} alt="Agro Valor" className="h-20 w-20 object-contain mb-6" style={{ mixBlendMode: "darken" }} />
          <div className="eyebrow mb-3">{t.admin.loginSub}</div>
          <h1 className="font-display text-4xl text-olive">{t.admin.loginTitle}</h1>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-2">
          <div className="flex flex-col gap-1 py-3">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft">{t.admin.email}</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="input-editorial"
            />
          </div>
          <div className="flex flex-col gap-1 py-3">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-olive-soft">{t.admin.password}</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="input-editorial"
            />
          </div>
          {err && <div data-testid="admin-login-error" className="font-mono text-[11px] uppercase tracking-[0.2em] text-terracotta mt-2">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="mt-8 bg-olive text-ivory px-7 py-4 font-mono text-[11px] tracking-[0.28em] uppercase hover:bg-terracotta transition-all duration-500 disabled:opacity-50"
          >
            {loading ? "…" : t.admin.enter}
          </button>
        </form>
      </div>
    </main>
  );
}
